<template>
    <div class="mb-5">
        <div class="d-flex mb-5 ml-auto justify-content-end" v-if="frenchDesc !== null && frenchDesc !== ''">
            <v-btn :color="primaryColor" class="mr-2 text-none" @click="generateTranslation" :disabled="loading">
                <v-icon left color="white">translate</v-icon>
                <span class="text-white">Générer une traduction</span>
            </v-btn>
        </div>

        <v-expand-transition class="mt-5">
            <div v-if="loading" class="d-flex flex-column align-center">
                <v-progress-circular indeterminate size="50" :color="primaryColor"></v-progress-circular>
                <span class="text-primary">Nous vous préparons une traduction. N’hésitez pas à l’améliorer !</span>
            </div>

            <v-alert v-else-if="generated">
                <div class="mb-5">Traduction suggérée :</div>

                <div class="ai-suggested-content" style="white-space: pre-wrap">{{ content }}</div>

                <div class="mt-5 text-center d-flex flex-wrap justify-center">
                    <v-btn :color="primaryColor" class="mr-2 mt-2 mb-2 text-none text-white" rounded
                           @click="acceptContent">
                        <v-icon>done</v-icon>
                        Remplacer ma description
                    </v-btn>

                    <v-btn color="error" class="mr-2 mt-2 mb-2 text-none text-white" rounded @click="cancelGeneration">
                        <v-icon>close</v-icon>
                        Ignorer la suggestion
                    </v-btn>
                </div>
            </v-alert>
        </v-expand-transition>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ContentDeeplTranslation",
    props: ["accountId"],
    data() {
        return {
            content: null,
            loading: false,
            generated: false,
        }
    },
    methods: {
        generateTranslation() {
            let payload = {
                frenchText: this.frenchDesc,
                accountId: this.accountId,
            }

            this.loading = true
            this.generated = false

            this.$http.post("textual/generate-translation", payload).then(res => {
                this.content = res.body.data.translation

                this.loading = false
                this.generated = true
            })
        },
        cancelGeneration() {
            this.content = null
            this.generated = false
        },
        acceptContent() {
            this.$global.$emit("accept-translation", {
                content: this.content,
            })

            this.generated = false
        },
    },
    computed: {
        ...mapState("web_form", [
            "provider",
        ]),
        ...mapState("webFormStyle", [
            "fontFamily",
            "primaryColor",
            "titlesColor",
            "fieldsColor",
            "backGroundColor"]),
        frenchDesc() {
            return this.provider.contents.find(content => content.language.code === "fr").description_long
        },
    },
}
</script>